import PuppySellAPI from "@/app/apis/main/puppy-sell/puppy-sell-api.js"

export default {
	/**
	 * @param puppyDetails
	 * @return {object} No content
	 */
	async savePuppyDetails(puppyDetails) {
		return PuppySellAPI.savePuppyDetails(puppyDetails)
	},

	async getPuppySellDetails(puppySellId) {
		return PuppySellAPI.getPuppySellDetails(puppySellId)
	},

	async getUserPuppySellList(queryParams) {
		return PuppySellAPI.getUserPuppySellList(queryParams)
	},

	async getAllApprovedPuppySellList(queryParams) {
		return PuppySellAPI.getAllApprovedPuppySellList(queryParams)
	},

	async updateUserPuppyDetails(puppyDetails) {
		return PuppySellAPI.updateUserPuppyDetails(puppyDetails)
	},

	async getPuppySellDetailsById(puppyToSellId) {
		return PuppySellAPI.getPuppySellDetailsById(puppyToSellId)
	},

	async processUserActivationAndPuppyDetails(referenceNumber) {
		return PuppySellAPI.processUserActivationAndPuppyDetails(referenceNumber)
	},

	async purchasePuppyVerify(verifyDetails) {
		return PuppySellAPI.purchasePuppyVerify(verifyDetails)
	},

	async purchasePuppyVerifyPlus(verifyDetails) {
		return PuppySellAPI.purchasePuppyVerifyPlus(verifyDetails)
	},

	async puppyCheckoutWithLpCard(paymentDetails) {
		return PuppySellAPI.puppyCheckoutWithLpCard(paymentDetails)
	},

	async sendEmailPuppyPurchase(details) {
		return PuppySellAPI.sendEmailPuppyPurchase(details)
	},

	async getPuppyPurchase(details) {
		return PuppySellAPI.getPuppyPurchase(details)
	},

	async reapprovedPuppyDetails(puppyDetails) {
		return PuppySellAPI.reapprovedPuppyDetails(puppyDetails)
	},

	async getPuppyPurchasedList(queryParams) {
		return PuppySellAPI.getPuppyPurchasedList(queryParams)
	},

	async getPuppyPurchasedDescription(puppyId) {
		return PuppySellAPI.getPuppyPurchasedDescription(puppyId)
	},

	async postPuppyRequestRefund(details) {
		return PuppySellAPI.postPuppyRequestRefund(details)
	},

	async putDeletePuppyToSell(puppySellId) {
		return PuppySellAPI.putDeletePuppyToSell(puppySellId)
	},

	async cancelPuppyPurchase(puppyPurchaseId) {
		return PuppySellAPI.cancelPuppyPurchase(puppyPurchaseId)
	},

	async updatePuppyDetailsStatus(puppySellId, details) {
		return PuppySellAPI.updatePuppyDetailsStatus(puppySellId, details)
	},
	async getPuppyPurchaseDetailsPayment(queryParams) {
		return PuppySellAPI.getPuppyPurchaseDetailsPayment(queryParams)
	},
}
